import ru from 'vuetify/es5/locale/ru'

export default {
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#000000',
        secondary: '#626262',
        accent: '#6a36ff',
        error: '#f54545',
        warning: '#FB7429',
        info: '#237bff',
        success: '#4DC912',
        background: '#E9E9E9',
        anchor: '#1e70eb',
        blue: '#32d3ff',
        white: '#FFFFFF',
        'light-green': '#F4FCF3',
      },
    },
  },
  lang: {
    locales: { ru },
    current: 'ru',
  },
}
